import { render, staticRenderFns } from "./Optin.vue?vue&type=template&id=479b7a56&"
import script from "./Optin.vue?vue&type=script&lang=js&"
export * from "./Optin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/production/spf-sexosafe-ezplatform/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('479b7a56')) {
      api.createRecord('479b7a56', component.options)
    } else {
      api.reload('479b7a56', component.options)
    }
    module.hot.accept("./Optin.vue?vue&type=template&id=479b7a56&", function () {
      api.rerender('479b7a56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/TestForm/components/Optin/Optin.vue"
export default component.exports